module.exports = __webpack_public_path__ + "img/framenew_box01.cd1c032a.jpg";